import { render, staticRenderFns } from "./InviteLose.vue?vue&type=template&id=6d8d2bd6&scoped=true"
import script from "./InviteLose.vue?vue&type=script&lang=js"
export * from "./InviteLose.vue?vue&type=script&lang=js"
import style0 from "./InviteLose.vue?vue&type=style&index=0&id=6d8d2bd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8d2bd6",
  null
  
)

export default component.exports